<div *ngIf="teacherActivity" class="info-card-modal">
  <div class="modal-header">
    <div>
      <div class="activity-type">{{ teacherActivity.type }}</div>
      <h4 class="activity-title">{{ teacherActivity.title }}</h4>
    </div>
    <button type="button" class="round-btn ml-auto" [attr.aria-label]="'CLOSE' | translate" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div [innerHTML]="teacherActivity.description | sanitizeHtml" class="description border-bottom"></div>

    <div class="activity-meta">
      <div class="meta-label"><i class="icon ftmi-teacher"></i> {{ 'TEACHER' | translate }}</div>
      {{ teacher?.user?.title?.name }}
      {{ teacher?.user?.firstName }}
      {{ teacher?.user?.lastName }}
    </div>
    <div class="activity-meta">
      <div class="meta-label"><i class="icon ftmi-location"></i> {{ 'ROOM' | translate }}</div>
      <div>
        {{ teacherActivity.room?.name }}
      </div>
    </div>
    <div class="activity-meta">
      <div class="meta-label"><i class="icon ftmi-group"></i> {{ 'MAX_ATTENDEES' | translate }}</div>
      <div>{{ teacherActivity.maxAttendees }}</div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary btn-padded btn-radius" (click)="onClose()">
      {{ 'CLOSE' | translate }}
    </button>
  </div>
</div>
